import type { RootState } from '../store'
import type { Habit } from '../../Models/Habit'

export const selectHabitsStatus = (state: RootState) => state.habits.status

export const selectActiveHabits = (state: RootState): Habit[] =>
  state.habits.items.filter((h) => !h.archivedAt)

export const selectArchivedHabits = (state: RootState): Habit[] =>
  state.habits.items.filter((h) => !!h.archivedAt)

export const selectCompletionsForWeek =
  (weekStart: string) =>
  (state: RootState): Record<string, string[]> =>
    state.habits.completionsByWeek[weekStart] ?? {}
